<template class="font-sans">
  <Suspense>
    <transition name="load">
      <div>
        <div v-show="showLoading">
          <LoadingOverlay />
        </div>
        <NavbarComponent />
        <div class="container mx-auto min-h-screen">
          <RouterView />
        </div>
        <FooterComponent />
      </div>
    </transition>
  </Suspense>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { useLanguageStore } from '@/stores/languages'
import { RouterView } from 'vue-router'

import FooterComponent from '@/components/FooterComponent.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import NavbarComponent from '@/components/NavbarComponent.vue'
import { storeToRefs } from 'pinia'
import { useAlertStore } from './stores/alerts'
import { useClientStore } from './stores/client'
import { useI18n } from 'vue-i18n'
import { onMounted, ref } from 'vue'


const languageStore = useLanguageStore()
const authStore = useAuthStore()
const clientStore = useClientStore()
const alertStore = useAlertStore()
const { mergeLocaleMessage } = useI18n()

const { showLoading } = storeToRefs(languageStore);


const initActiveGrowthplanForUser = async () => {
  if (authStore.loggedIn && authStore.role === "User") {
    try {
      await clientStore.retrieveUserActiveGrowthplan()
    } catch (error) {
      alertStore.handleError(error)
    }
  }
}

onMounted(async () => {
  showLoading.value = true
  await languageStore.handleLoadingLang(languageStore.selectedLanguage);

  await initActiveGrowthplanForUser()
  showLoading.value = false
})


</script>
